var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06473 8.00288C5.52382 7.77042 5.00639 7.47917 4.55371 7.19136C3.6049 6.58812 2.5 5 2.5 5M4.55371 7.19136L2 9M6.06473 8.00288C6.72139 8.2851 7.28862 8.43081 8 8.5M6.06473 8.00288L4.9541 10.5435M8 8.5C8 9.47631 8 11 8 11M8 8.5C8.70102 8.44918 9.38503 8.2817 10.0302 8.00288M11.533 7.19136C12.4766 6.58812 13.5 5 13.5 5M11.533 7.19136L14 9M11.533 7.19136C11.0828 7.47917 10.5178 7.78426 10.0302 8.00288M10.0302 8.00288C10.4676 8.99505 11.1503 10.5435 11.1503 10.5435",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/close_eye.6c0325e313fefb3d6760645c65d3f9e4.svg";
export { ForwardRef as ReactComponent };